import React, { Component} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CreateAsset from './createAsset';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Edit from '@material-ui/icons/Edit';
import ForwardIcon from '@material-ui/icons/Forward';
import axios from 'axios';
import * as constants from '../config/constants';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DeleteIcon from '@material-ui/icons/Delete';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import red from '@material-ui/core/colors/red';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

function TabContainer(props) {
	return (
		<Typography component="div">
		{props.children}
		</Typography>
		);
}

TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
};

const CustomTableCell = withStyles(theme => ({
	head: {
		backgroundColor: theme.palette.grey[200],
		color: theme.palette.common.black,
		textTransform: 'uppercase',
		fontWeight: 700
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const styles = theme => ({
	button: {
		margin: theme.spacing.unit,
	},
	table: {
		minWidth: 700,
	},
	root: {
		width: '100%',
		marginTop: theme.spacing.unit * 3,
		overflowX: 'auto',
	}
});

class Asset extends Component {
	constructor() {
		super();
		this.state = {
			open : false,
			asset : [],
			category : [],
			selectAll: false,
			searchTerm :'',
			selectedCount: 0,
			currentAsset: null,
			deleteDialog: false,
			deleteConfirmation: '',
			tabValue: 0,
			visible : false
		}
		this.handleCreateAssetDialog = this.handleCreateAssetDialog.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.closeCB = this.closeCB.bind(this);
		this.createCB = this.createCB.bind(this);
		this.handleCheckBox = this.handleCheckBox.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleDownloadQR = this.handleDownloadQR.bind(this);
		this.toggleDeleteDialog = this.toggleDeleteDialog.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleTabChange = this.handleTabChange.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	}
	handleSearch = (event) => {
		let copiedStates = Object.assign({}, this.state);
		if(event.target.value !== '') {
			let	regex = new RegExp((event.target.value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')) , 'ig');
			for(var key in copiedStates.asset) {
				if((copiedStates.asset[key].name.search(regex) > -1)
					|| (copiedStates.asset[key].id.search(regex) > -1)
					|| (copiedStates.asset[key].admin.search(regex) > -1)
					|| (copiedStates.asset[key].description.search(regex) > -1)
					|| (copiedStates.asset[key].category.type.search(regex) > -1)
					|| (copiedStates.asset[key].price.toString().search(regex) > -1)
					|| (copiedStates.asset[key].category.name.search(regex) > -1)
					|| (copiedStates.asset[key].vendor.name.search(regex) > -1)) 
				{
					copiedStates.asset[key].visible = true;	
				}
				else
					copiedStates.asset[key].visible = false;
			}
		} else {
			copiedStates.asset.map(a => {
				a.visible = true;
			});
		}
		copiedStates.searchTerm = event.target.value;
		this.setState(copiedStates);
	}
	handleTabChange = (event, value) => {
		this.setState({
			tabValue: value
		});
	}
	handleInputChange = (event) => {
		let copiedStates = Object.assign({},this.state);
		copiedStates[event.target.name] = event.target.value;
		this.setState(copiedStates);
	}
	toggleDeleteDialog = (currentAsset) => {
		let copiedStates = Object.assign({},this.state);
		copiedStates.deleteDialog = !copiedStates.deleteDialog;
		copiedStates.currentAsset = currentAsset;
		this.setState(copiedStates);
	}
	handleDelete = () => {
		let that = this;
		let { currentAsset } = this.state;
		let copiedStates = Object.assign({},this.state);
		let request = {
			status: 'D'
		}
		axios.put(constants.API_BASE_URL + "asset/" + currentAsset.id,request)
		.then(function (response) {
			copiedStates.asset = copiedStates.asset.map(a => {
				if(a.id === currentAsset.id) {
					a = response.data.details;
				}
				return a;
			});
			copiedStates.deleteDialog = false;
			that.setState(copiedStates);
		})
		.catch(function (error) {
		});
	}
	handleDownloadQR = () => {
		let copiedStates = Object.assign({}, this.state);
		let toGenerateQR = [];
		copiedStates.asset.map(a => {
			if(a.selected === true) {
				toGenerateQR.push(a.id);
			}
		});
		let urlEncodedIds = toGenerateQR.join(',');
		window.open(constants.PRODUCT_BASE_URL + "generateQR?ids=" + urlEncodedIds);
	}
	handleCheckBox = (assetToChange) => {
		let copiedStates = Object.assign({}, this.state);
		let selectedCount = 0;
		if(assetToChange === "*") {
			copiedStates.asset.map(a => {
				a.selected = !copiedStates.selectAll;
				a.selected && selectedCount++;
			});
		} else {
			copiedStates.asset.map(a => {
				if(assetToChange.id === a.id) {
					a.selected = !a.selected
				}
				a.selected && selectedCount++;
			});
		}
		copiedStates.selectAll = selectedCount === copiedStates.asset.length ? true : false;
		copiedStates.selectedCount = selectedCount;
		this.setState(copiedStates);
	}
	closeCB = () => {
		let copiedStates = Object.assign({}, this.state);
		copiedStates.open = false;
		copiedStates.currentAsset = null;
		this.setState(copiedStates);
	}
	handleEdit = (currentAsset) => {
		let copiedStates =Object.assign({},this.state);
		copiedStates.open = true;
		copiedStates.currentAsset = currentAsset;
		this.setState(copiedStates);
	}
	createCB = (asset) => {
		let copiedStates = Object.assign({}, this.state);
		if(copiedStates.currentAsset) {
			copiedStates.asset.map((a, i) => {
				if(a.id === asset.id) {
					copiedStates.asset[i] = asset;
					copiedStates.asset[i].visible = true;
				}
			});
			copiedStates.currentAsset = null;
		} else {
			if(!Array.isArray(asset)) {
				asset.visible = true;
				copiedStates.asset.unshift(asset);
			}
			else {
				asset.map(a => {
					a.visible = true;
				})
				copiedStates.asset = copiedStates.asset.concat(asset);
			}
		}
		copiedStates.open = false;
		console.log("createCB", copiedStates);
		this.setState(copiedStates);
	}
	componentDidMount() {
		let copiedStates = Object.assign({},this.state);
		let that = this;
		axios.get(constants.API_BASE_URL + "asset")
		.then(function(response){
			let asset = [];
			response.data.details.map(a => {
				a.selected = false;
				a.visible = true;
			});
			copiedStates.asset = response.data.details;
			that.setState(copiedStates);
		})
		.catch(function(error){
			alert(error);
		});
	}
	handleCreateAssetDialog = () => {
		this.setState({
			open : true
		});
	}
	render = () => {
		let assetArr = this.state.asset;
		let currentAssetComponent=[];
		let oldAssetComponent=[];
		assetArr.map((a,i) => {
			if(a.visible === true) {
				console.log("a.status", a.status);
				if(a.status === 'A') {
					currentAssetComponent.push(
						<TableRow>
						<TableCell>
						<Checkbox
						checked={assetArr[i].selected}
						onChange={() => this.handleCheckBox(assetArr[i])}
						/>
						</TableCell>
						<TableCell>
						{assetArr[i].id.split(":")[1]}
						</TableCell>
						<TableCell>
						{assetArr[i].name}
						</TableCell>
						<TableCell>
						{assetArr[i].category.name + " - " + assetArr[i].category.type}
						</TableCell>
						<TableCell>
						{assetArr[i].price}
						</TableCell>
						<TableCell>
						{assetArr[i].vendor.name}
						</TableCell>
						<TableCell>
						{assetArr[i].description}
						</TableCell>
						<TableCell>
						<IconButton onClick = {() => this.handleEdit(assetArr[i])}>
						<Edit />
						</IconButton>
						</TableCell>
						<TableCell>
						<IconButton 
						onClick = {() => this.toggleDeleteDialog(assetArr[i])}>
						<DeleteIcon />
						</IconButton>
						</TableCell>
						</TableRow>
						);
				} else {
					oldAssetComponent.push(
						<TableRow>
						<TableCell>
						{assetArr[i].id.split(":")[1]}
						</TableCell>
						<TableCell>
						{assetArr[i].name}
						</TableCell>
						<TableCell>
						{assetArr[i].category.name + " - " + assetArr[i].category.type}
						</TableCell>
						<TableCell>
						{assetArr[i].price}
						</TableCell>
						<TableCell>
						{assetArr[i].vendor.name}
						</TableCell>
						<TableCell>
						{assetArr[i].description}
						</TableCell>
						<TableCell>
						{assetArr[i].company}
						</TableCell>
						<TableCell>
						{assetArr[i].admin}
						</TableCell>
						</TableRow>
						);
				}
			}
		});
		const { classes } = this.props;
		return(
			<div>
			<Button style={{
				position: 'fixed',
				bottom: '20px',
				right: '15px',
				zIndex: 1001
			}}
			variant="fab" color="primary" aria-label="add" className={classes.button} onClick={this.handleCreateAssetDialog}>
			<AddIcon />
			</Button>
			{this.state.selectedCount > 0 && (
				<Button style={{
					position: 'fixed',
					bottom: '20px',
					left: '15px',
					zIndex: 1001
				}}
				variant="extendedFab" color="secondary" aria-label="add"
				className={classes.button} onClick={this.handleDownloadQR}>
				<ForwardIcon style={{
					transform: 'rotate(90deg)'
				}} />
				Download QR
				</Button>
				)}

			<Dialog
			open={this.state.deleteDialog}
			onClose={() => this.toggleDeleteDialog()}
			>
			<DialogTitle>Delete asset</DialogTitle>
			<DialogContent>
			<DialogContentText>
			If you are deleting an asset which is allocated to one or more associates, it will be deallocated.
			<br />
			Do you want to delete the asset? Type DELETE below
			</DialogContentText>
			<TextField
			multi
			autoFocus
			margin="dense"
			name="deleteConfirmation"
			type="text"
			onChange={this.handleInputChange}
			fullWidth
			/>
			</DialogContent>
			<DialogActions>
			<Button onClick={() => this.toggleDeleteDialog()} color="primary">
			Cancel
			</Button>
			<Button onClick={this.handleDelete}
			disabled={!(this.state.deleteConfirmation === "DELETE")}
			style={{
				color: (this.state.deleteConfirmation === "DELETE") ? red[500] : "grey"
			}}
			>
			DELETE
			</Button>
			</DialogActions>
			</Dialog>

			<Paper className={classes.root}>

			<AppBar position="static" color="default">
			<Tabs 
			fullWidth
			centered
			value={this.state.tabValue} onChange={this.handleTabChange}>
			<Tab label="Current" />
			<Tab label="History" />
			</Tabs>
			</AppBar>
			<div style={{
				padding: '15px',
				width: '100%'
			}}>
			<Typography variant="title" style={{
				textTransform: 'uppercase',
				float: 'left'
			}} >Asset</Typography>

			<TextField
			style ={{
				float: 'right'
			}}
			id="searchTerm"
			name="searchTerm"
			placeholder="Search"
			value={this.state.searchTerm}
			onChange={this.handleSearch}
			margin="normal"
			/>
			</div>
			<div style={{
				clear:'both'
			}}></div>
			<div style={{
				overflow: "auto",

			}} >
			<Table className={classes.table}>
			<TableHead>
			{this.state.tabValue === 0 ? (
				<TableRow>
				<CustomTableCell>
				<Checkbox
				indeterminate={this.state.selectedCount > 0 && this.state.selectedCount < this.state.asset.length}
				checked={this.state.selectAll}
				onChange={() => this.handleCheckBox('*')}
				/>
				</CustomTableCell>
				<CustomTableCell>ID</CustomTableCell>
				<CustomTableCell>Name</CustomTableCell>
				<CustomTableCell>Category - Type</CustomTableCell>
				<CustomTableCell>Est. value</CustomTableCell>
				<CustomTableCell>Vendor</CustomTableCell>
				<CustomTableCell>Desc.</CustomTableCell>
				<CustomTableCell>Edit</CustomTableCell>
				<CustomTableCell>Delete</CustomTableCell>
				</TableRow>
				) : (
				<TableRow>
				<CustomTableCell>ID</CustomTableCell>
				<CustomTableCell>Name</CustomTableCell>
				<CustomTableCell>Category - Type</CustomTableCell>
				<CustomTableCell>Est. value</CustomTableCell>
				<CustomTableCell>Vendor</CustomTableCell>
				<CustomTableCell>Desc.</CustomTableCell>
				<CustomTableCell>Company</CustomTableCell>
				<CustomTableCell>Admin</CustomTableCell>
				</TableRow>
				)}

				</TableHead>
				<TableBody>
				{this.state.tabValue === 0 ? currentAssetComponent : oldAssetComponent}
				</TableBody>
				</Table>
				</div>

				</Paper>
				<CreateAsset 
				open = {this.state.open}
				currentAsset = {this.state.currentAsset}
				closeCB = {this.closeCB}
				createCB = {this.createCB}
				/>
				</div>
				)
	}
}
Asset.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Asset);


// WEBPACK FOOTER //
// ./src/asset/asset.js